<template>
  <div id="container">
    <div class="product-status">
      <el-form class="search-style">
        <el-row :gutter="20">
          <el-col :span="16" style="padding-left:0px;">
            <el-col :span="6">
              <el-form-item>
                <el-select v-model="queryParams.column" @change="changeColumn">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="item in supplierNameList"
                    :key="item.label"
                  ></el-option>
                  <el-option label="代理品牌" value="cusImplevel"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col
              :span="6"
              v-show="queryParams.column==='accountBalance'||queryParams.column==='supplierTradeAmount'||queryParams.column==='contractNumber'"
            >
              <el-form-item>
                <el-select v-model="queryParams.expression">
                  <el-option
                    :label="item.label"
                    :value="item.value"
                    v-for="(item,index) in expressionList"
                    :key="index"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-select v-model="queryParams.value" v-if="queryParams.column==='suType'">
                  <el-option label="平台渠道" :value="1"></el-option>
                  <el-option label="供应商" :value="2"></el-option>
                  <el-option label="厂家" :value="3"></el-option>
                  <el-option label="经销商" :value="4"></el-option>
                </el-select>
                <el-input
                  v-else-if="queryParams.column==='accountBalance'||queryParams.column==='supplierTradeAmount'||queryParams.column==='contractNumber'"
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                  v-model="queryParams.value"
                  placeholder="请输入关键词"
                ></el-input>
                <el-input v-else v-model="queryParams.value" placeholder="请输入关键词"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <el-button @click="onSearch" type="primary">搜索</el-button>
                <el-button @click="onReset" plain>重置</el-button>
              </el-form-item>
            </el-col>
          </el-col>
          <el-col style="text-align:right;" :span="8">
            <el-form-item>
              <el-button
                type="primary"
                @click="allocationName(2)"
                plain
                :disabled="disabled"
              >批量分配负责人</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table box-style" :style="{height:tableHeight+'px'}">
        <el-table
          ref="multipleTable"
          :data="supplierTable"
          tooltip-effect="dark"
          :max-height="tableHeight"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            :selectable="selectableFun"
            width="35"
            v-if="activeName==='1'||activeName==='2'"
          ></el-table-column>
          <el-table-column label="供应商编号" width="110" show-overflow-tooltip>
            <template slot-scope="scope">
              <div>{{scope.row.suCode || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="供应商名称" show-overflow-tooltip min-width="120">
            <template slot-scope="scope">
              <div
                :class="scope.row.id? 'skip line-limit-length':'line-limit-length'"
                @click="onEdit(scope.row)"
              >{{scope.row.suName }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="suType" label="供应商类型" width="110">
            <template
              slot-scope="scope"
            >{{ scope.row.suType=== 1 ? '平台渠道' : scope.row.suType=== 2 ? '供应商' : scope.row.suType=== 3 ? '厂家' : scope.row.suType=== 4 ? '经销商':''}}</template>
          </el-table-column>
          <el-table-column label="可用余额">
            <template slot-scope="scope">
              <span v-if="scope.row.id">{{scope.row.accountBalance | priceFilterNum}}</span>
            </template>
          </el-table-column>
          <el-table-column label="贸易总额">
            <template slot-scope="scope">
              <span v-if="scope.row.id">{{scope.row.supplierTradeAmount | priceFilterNum}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="contractNumber" label="合同总数">
            <template slot-scope="scope">
              <span v-if="scope.row.id">{{String(scope.row.contractNumber) || '--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="suContacts" label="联系人">
            <template slot-scope="scope">{{ scope.row.suContacts}}</template>
          </el-table-column>
          <el-table-column prop="suPhone" show-overflow-tooltip label="电话">
            <template slot-scope="scope">
              <div class="line-limit-length">{{ scope.row.suPhone }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="suMobile" show-overflow-tooltip label="手机号">
            <template slot-scope="scope">
              <div class="line-limit-length" v-if="scope.row.id">{{scope.row.suMobile || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column label="代理品牌" show-overflow-tooltip min-width="90">
            <template slot-scope="scope">
              <div class="line-limit-length" v-if="scope.row.id">{{ scope.row.src || '--'}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="createUser" label="添加人">
            <template slot-scope="scope">{{ scope.row.createUser }}</template>
          </el-table-column>
          <el-table-column label="添加时间" width="135">
            <template slot-scope="scope">
              <span v-if="scope.row.id">{{scope.row.createDate | dateFilterL}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="editUser" label="黑名单添加人" width="110" v-if="activeName==='3'"></el-table-column>
          <el-table-column label="负责人" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="line-limit-length" v-if="scope.row.id">{{ scope.row.staff || '--'}}</div>
              <div class="line-limit-length" v-else>{{ scope.row.staff}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" :disabled="disabled" @click="allocationName(1,scope.row)">分配负责人</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
      <!-- 分配负责人 -->
      <el-dialog
        :visible="dialogVisible"
        width="25%"
        :title="`设置负责人`"
        class="addBrand"
        @close="onClose"
      >
        <el-form
          :model="paramsPrincipal"
          ref="queryParamsRefs"
          :rules="queryParamsRules"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item label="角色名称： " label-width="100px" prop="roleName">
            <el-row>
              <el-col :span="24">
                <el-select
                  v-model="paramsPrincipal.roleName"
                  multiple
                  placeholder="角色"
                  @change="changeRole"
                >
                  <el-option v-for="(v,i) in roleList" :key="i" :label="v.roleName" :value="v.id"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="员工名称： " label-width="100px" prop="groupName">
            <el-row>
              <el-col :span="24">
                <el-select
                  v-model="paramsPrincipal.groupName"
                  @remove-tag="remove"
                  multiple
                  placeholder="员工名称"
                  @change="getGroupName"
                >
                  <el-option
                    v-for="v in staffList"
                    :key="v.id"
                    :label="v.staffCnName"
                    :value="v.id"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="onSubmit">确 定</el-button>
          <el-button @click="dialogVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 取消负责人 -->
      <el-dialog @close="close" :visible="cancleDialog" width="25%" title="转移合同" class="addBrand">
        <el-form
          :model="cancleParams"
          ref="cancleParamsRefs"
          :rules="cancleParamsRules"
          label-width="80px"
          class="demo-ruleForm"
        >
          <el-form-item label="选择负责人： " label-width="100px" prop="cancleName">
            <el-row>
              <el-col :span="22">
                <el-select
                  @change="changeStaff"
                  v-model="cancleParams.cancleName"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="(v,i) in staffList"
                    :key="i"
                    :label="v.staffCnName"
                    :value="v.id"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="confirm">确 定</el-button>
          <el-button @click="close">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { isSuccess } from '@/util/tool'
import {
  queryAllSupplierBaseById,
  querySupplierBaseAll,
  updatePrincipal,
  purchaseContract
} from '@/api/supplier/supplierManage'
import {
  getgroupList,
  getAllStaff,
  getroleInfo
} from '@/api/system/rightsManagement'
import { supplierTabs, supplierNameList } from './utils/data'
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'

export default {
  components: {
    pagination
  },
  data() {
    return {
      cancleDialog: false,
      roleList: [],
      staffList: [],
      allstaff: [],
      that: this,
      dialogVisible: false,
      disabled: false,
      tableHeight: window.innerHeight - 320,
      activeName: '1',
      supplierTabs: [],
      queryParams: {
        column: 'suName',
        value: ''
      },
      queryParamsRules: {
        roleName: [
          {
            required: true,
            message: '角色名称不能为空',
            trigger: 'blur'
          }
        ],
        groupName: [
          {
            required: true,
            trigger: 'blur',
            message: '至少选择一名负责人'
          }
        ]
      },
      paramsPrincipal: {
        roleName: [],
        groupName: []
      },
      cancleParamsRules: {
        cancleName: [
          {
            required: true,
            trigger: 'blur',
            message: '至少选择一名负责人'
          }
        ]
      },
      cancleParams: {
        cancleName: ''
      },
      curRow: {}, // 当前选中row
      selectList: [],
      expressionList: [],
      supplierNameList,
      supplierTable: [],
      loadingTable: false,
      total: 0,
      currentPage: 1, // 当前页
      pageSize: 30, // 分页页数
      serchList: [],
      suIds: [], // 供应商id
      oldOwnId: '', // 原负责人id
      suId: '', // 供应商id
      moveList: [],
      state: '',
      isDialog: false,
      tempList: [],
      newArr: [],
      principalVoList: [] // 负责人信息
    }
  },
  watch: {
    queryParams(val) {
      if (!val.column) {
        this.$set(this.queryParams, 'column', 'suName')
      }
    }
  },
  mounted() {
    if (this.$route.query.cusState) {
      this.activeName = this.$route.query.cusState
    }
    this.getList()
    this.supplierTabs = supplierTabs
    this.expressionList = expressionList
    this.getgroupList() // 角色列表
    this.getAllStaff() // 所有员工列表
  },
  filters: {
    formatPersonCharge(data, that) {
      if (!data) return ''
      const ids = data.split(',')
      const { allstaff } = that
      let names = ''
      ids.forEach(id => {
        if (id !== '') {
          const obj = allstaff.find(items => {
            const str = items.sbId + ''
            return str === id
          })
          if (obj) {
            names = names + obj.staffCnName + ','
          }
        }
      })
      return names.substring(0, names.length - 1)
    }
  },
  methods: {
    // 禁用复选框
    selectableFun(row) {
      if (row.id !== 0) {
        return true
      } else {
        return false
      }
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
    // 切换tabs
    handleClick(val) {
      this.activeName = val.name
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    getList() {
      this.loadingTable = true
      const params = {
        criteriaVoList: [],
        queryPageName: ''
      }
      if (this.queryParams.value) {
        params.criteriaVoList = [...this.serchList]
      }
      querySupplierBaseAll(0, this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.supplierTable = res.data.obj.records
            this.total = res.data.obj.total

            res.data.obj.records.forEach(ele => {
              // 代理品牌处理
              ele.brandBaseList = ele.brandBaseList || []
              const arr = []
              ele.brandBaseList.forEach(item => arr.push(item.brandName))
              ele.src = arr.join(',')

              // 负责人处理
              const staffs = []
              ele.principalVoList.forEach(items =>
                staffs.push(items.staffCnName)
              )
              ele.staff = staffs.join(',')

              // 操作禁用
              if (this.supplierTable[0].principalVoList === []) {
                this.disabled = true
              } else {
                this.disabled = false
              }
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 选择客户名称触发后面符号可选不可选
    changeColumn() {
      delete this.queryParams.value
      this.$set(this.queryParams, 'expression', null)
      if (
        this.queryParams.column === 'accountBalance' &&
        this.queryParams.column === 'supplierTradeAmount'
      ) {
        this.queryParams.expression = 'eq'
      }
    },
    onReset() {
      // 重置
      this.serchList = []
      this.queryParams = {}
      this.currentPage = 1
      this.pageSize = 30
      this.getList()
    },
    // 搜索
    onSearch() {
      if (this.queryParams.column && this.queryParams.value) {
        this.serchList = [this.queryParams]
        this.currentPage = 1
        this.pageSize = 30
        this.getList()
      } else {
        this.$message.error('搜索条件不能为空')
      }
    },
    // 分配负责人
    allocationName(type, row) {
      if (type === 1) {
        this.curRow = row
        this.paramsPrincipal.roleName = row.roleIds
        this.changeRole(row.roleIds)
        this.paramsPrincipal.groupName = []
        row.principalVoList.forEach(ele => {
          this.paramsPrincipal.groupName.push(ele.staffId)
        })
        this.suIds.push(row.id)
        this.suId = row.id // 供应商id
        this.dialogVisible = true
        this.moveList = row.principalVoList
      } else {
        if (this.selectList === undefined || this.selectList.length <= 0) {
          this.$message.error('请选择要设置负责人的供应商！')
        } else {
          this.selectList.forEach(ele => {
            this.suIds.push(ele.id)
          })
          this.dialogVisible = true
        }
      }
    },

    // 获取角色
    getgroupList() {
      getgroupList().then(res => {
        if (isSuccess(res)) {
          this.roleList = res.data.obj.systemRoleList
        }
      })
    },
    // 获取员工名称
    getAllStaff() {
      getAllStaff().then(res => {
        if (isSuccess(res)) {
          this.allstaff = res.data.obj.records.map(item => {
            item.id = item.sbId
            return item
          })
        }
      })
    },
    // 选择角色名称-显示员工名称
    changeRole(data) {
      const { curRow, supplierTable } = this
      if (!data || data.length === 0) {
        this.staffList = []
      } else {
        getroleInfo(data).then(res => {
          if (isSuccess(res)) {
            const data = res.data.obj
            if (curRow.id === 0) {
              this.staffList = data
              // 删除重复员工
              const hash = {}
              this.staffList = this.staffList.reduce(function(item, next) {
                // eslint-disable-next-line no-unused-expressions
                hash[next.staffCnName]
                  ? ''
                  : (hash[next.staffCnName] = true && item.push(next))
                return item
              }, [])
            } else {
              const rowids = supplierTable[0].principalVoList
              this.staffList = data.filter(
                item => !rowids.find(ex => ex.staffId === item.id)
              )
            }
          }
        })
      }
    },
    // 选择员工名称
    getGroupName(val) {},
    // 清除员工名称
    remove(val) {
      const obj = this.moveList.find(m => m.staffId === val)
      const state = obj.state
      this.oldOwnId = obj.staffId // 原负责人id
      if (state === 1) {
        // 1需转移合同
        this.isDialog = false
        this.cancleDialog = true
      }
    },
    // 选择负责人
    changeStaff(val) {
      this.ownId = val
      this.$refs.cancleParamsRefs.clearValidate() // 去掉校验
    },
    // 转移合同确定
    confirm() {
      this.$refs.cancleParamsRefs.validate(valid => {
        if (valid) {
          // 校验通过
          purchaseContract(this.suId, this.ownId, this.oldOwnId).then(res => {
            if (res.data.code === 200) {
              this.$message.success('操作成功')
              this.cancleDialog = false
              this.isDialog = true
              this.cancleParams.cancleName = ''
              this.paramsPrincipal.groupName.push(this.ownId)
            }
          })
        } else {
          return false
        }
      })
    },
    // 取消合同转移
    close() {
      if (this.isDialog) {
      } else {
        this.cancleDialog = false
        this.cancleParams.cancleName = ''
        this.$refs.cancleParamsRefs.clearValidate() // 去掉校验
        if (!this.paramsPrincipal.groupName.find(m => m === this.oldOwnId)) {
          this.paramsPrincipal.groupName.push(this.oldOwnId)
        }
      }
    },
    // 确定
    onSubmit() {
      this.$refs.queryParamsRefs.validate(valid => {
        if (valid) {
          this.principalVoList = []
          this.paramsPrincipal.groupName.forEach(ele => {
            const obj = this.staffList.find(m => m.id === ele)
            this.principalVoList.push({
              staffId: obj.id,
              staffCnName: obj.staffCnName
            })
          })
          const update = {
            principalVoList: this.principalVoList, // 负责人信息
            suIds: this.suIds
          }
          updatePrincipal(update).then(res => {
            if (res.data.code === 200) {
              this.$message.success('操作成功')
              this.dialogVisible = false
              this.getList()
              this.suIds = []
            } else {
              this.$message.error(res.data.msg)
            }
          })
        }
      })
    },
    onClose() {
      this.paramsPrincipal = {
        roleName: [],
        groupName: []
      }
      this.dialogVisible = false
      this.selectList = []
      this.suIds = []
    },

    // 供应商跳转
    onEdit(row) {
      if (row.id) {
        queryAllSupplierBaseById(row.id)
          .then(res => {
            if (res.data.code === 200) {
              this.$router.push({
                path: '/crm/supplier/supplierEdit',
                query: { id: row.id }
              })
            } else {
              this.$message.error(res.data.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    // 设置头部背景色
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 分页页数
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 分页码数
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    }
  }
}
</script>
<style lang="scss" scoped>
.el-table .cell {
  white-space: pre-line !important;
}
</style>
